import { Schema } from "effect";
import type { Effect } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";

export const CatalogSelection = Schema.Struct({ workspaceId: Schema.NullOr(Schema.String), refreshToken: Schema.optionalKey(Schema.Number) });
export type CatalogSelection = typeof CatalogSelection.Type;
export interface CatalogSnapshot<A> {
  readonly workspaceId: string | null;
  readonly selectionEpoch: number;
  readonly value: A | null;
  readonly loading: boolean;
  readonly loaded: boolean;
  readonly error: string | null;
}
export interface CatalogSession<A> {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<CatalogSnapshot<A>>>;
  readonly read: Effect.Effect<CatalogSnapshot<A>>;
  readonly select: (selection: CatalogSelection) => Effect.Effect<void>;
  readonly refresh: Effect.Effect<void>;
  readonly clearError: Effect.Effect<void>;
}
export const emptyCatalog = <A>(workspaceId: string | null = null, selectionEpoch = 0): CatalogSnapshot<A> => ({ workspaceId, selectionEpoch, value: null, loading: false, loaded: workspaceId === null, error: null });
